import React from "react";
import NavbarDesktop from "../blocks/NavbarDesktop";
import NavbarMobile from "../blocks/NavbarMobile";
const Header = ({ settings, menu, contactInfo, pageData }) => {
  const { logo } = settings;
  // console.log(settings, menu, "menu");

  return (
    <header>
      <NavbarDesktop
        logo={logo}
        settings={settings}
        menu={menu}
        contactInfo={contactInfo}
        pageData={pageData}
      />

      <NavbarMobile
        logo={logo}
        settings={settings}
        menu={menu}
        contactInfo={contactInfo}
        pageData={pageData}
      />
    </header>
  );
};

export default Header;
